<!--
 * @Author: your name
 * @Date: 2022-03-17 09:57:50
 * @LastEditTime: 2022-03-17 15:09:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/integralExchange/index.vue
-->
<template>
  <div class="exchange">
    <div class="bg_color">
      <div class="exchangeName">当前积分</div>
      <div class="exchangeNum" @click="toDetails">
        <img :src="logoUrl" class="imgleft" />
        <span>{{ allIntegral }}</span>
        <span class="toDetail">></span>
      </div>
    </div>
    <p class="useIntegral">可用积分{{ integral }}</p>
    <div class="exchangeitem" v-for="(item, index) of rules" :key="index">
      <div class="itemleft">
        <p class="left_top">积分抵现</p>
        <p class="left_bot">
          <span>￥</span>
          <span class="bot_big">{{ item.amt }}</span>
        </p>
      </div>
      <div class="itemcenter">
        <p class="center_top">{{ item.amt }}元现金</p>
        <p class="center_bot">{{ item.name }}</p>
      </div>
      <div
        class="itemright"
        :class="Number(item.integral) > Number(integral) ? 'disabled' : ''"
        @click="hanleExchange(item)"
      >
        兑换
      </div>
      <Promptbox v-if="tips" :message="16"></Promptbox>
    </div>
    <loading v-if="load"></loading>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logoUrl: "/static/image/jifen.png",
      integral: 0,
      vipno: localStorage.getItem("VIPNO"),
      CompanyID: localStorage.getItem("companyID"),
      rules: [],
      tips: false,
      load: false,
      allIntegral: 0
    };
  },
  mounted() {
    this.getIntegral();
  },
  methods: {
    toDetails() {
      window.location.href = "/#/Integral";
    },
    getIntegral() {
      this.RequestVIP(
        `h5/vip/point/info?vipno=${this.vipno}&type=0`,
        r => {
          if (!!r.data.data.table1.length) {
            this.integral = r.data.data.table1[0].usintegral;
            this.allIntegral = r.data.data.table1[0].integral;
            this.getRules();
          }
        },
        err => console.log(err)
      );
    },
    getRules() {
      this.RequestVIP(
        `h5/vip/point/rules`,
        r => {
          console.log(r, "rrrrrrrr");
          this.rules = r.data.data.table1;
        },
        err => console.log(err)
      );
    },
    hanleExchange(data) {
      console.log(Number(data.integral), Number(this.integral));
      if (Number(data.integral) > Number(this.integral)) {
        alert("积分余额不足");
      } else {
        this.load = true;
        this.RequestVIP2(
          `h5/vip/point/exchange`,
          {
            vipno: this.vipno,
            point: Number(data.integral),
            money: Number(data.amt)
          },
          r => {
            console.log(r, "ressssssssss");
            if (r.data.code === "20000") {
              this.tips = true;
              setTimeout(() => {
                this.tips = false;
              }, 1000);
            } else {
              alert("兑换失败");
            }
            this.load = false;
            this.getIntegral();
          },
          err => console.log(err)
        );
      }
    }
  }
};
</script>

<style scoped>
.exchange {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: rgba(245, 245, 245, 0.39);
}
.bg_color {
  width: 250px;
  height: 110px;
  background: linear-gradient(310deg, #ff9c60 0%, #ff5a61 100%);
  opacity: 1;
  text-align: center;
  box-sizing: border-box;
  padding: 31px 0 0;
}
.exchangeName {
  font-size: 11px;
  height: 11px;
  width: 100%;
  text-align: center;
  font-weight: 400;
  line-height: 8px;
  color: #ffffff;
  opacity: 1;
}
.exchangeNum {
  width: 100%;
  text-align: center;
  font-size: 29px;
  font-weight: 500;
  color: #ffffff;
  vertical-align: middle;
}
.imgleft {
  width: 15px;
}
.toDetail {
  font-size: 15px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 600;
  margin-bottom: 6px;
}
.exchangeitem {
  width: 92%;
  height: 69px;

  background: white;
  opacity: 1;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  margin-left: 4%;
  margin-top: 9px;
  box-sizing: border-box;
  padding-right: 10px;
}
.itemleft {
  text-align: center;
  width: 69px;
  height: 69px;
  background: linear-gradient(135deg, #ffa516 0%, #f2553d 100%);
  opacity: 1;
  border-radius: 3px 0px 0px 3px;
}
.itemcenter {
  width: 100px;
  box-sizing: border-box;
  padding-left: 10px;
}
.itemright {
  width: 47px;
  height: 17px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  opacity: 1;
  border-radius: 15px;
  text-align: center;
  line-height: 18px;
  font-size: 8px;
  margin-top: 27px;
  color: #ffffff;
}
.disabled {
  background: rgba(189, 189, 189, 0.39);
}
.left_top {
  font-size: 10px;
  margin-top: 16px;
  line-height: 8px;
  color: #ffffff;
}
.left_bot {
  font-size: 12px;
  font-weight: bold;
  line-height: 35px;
  color: #ffffff;
  margin-top: 4px;
}
.bot_big {
  font-size: 21px;
  margin-left: -4px;
}
.center_top {
  font-size: 11px;
  margin-top: 18px;
  font-weight: 400;
  line-height: 8px;
  color: #212121;
}
.center_bot {
  font-size: 11px;
  margin-top: 18px;
  font-weight: 400;
  line-height: 8px;
  color: #f2553d;
}
.useIntegral {
  font-size: 8px;
  color: #ff5a61;
  margin: 6px 12px 0px;
}
</style>



// WEBPACK FOOTER //
// src/integralExchange/index.vue